import { render, staticRenderFns } from "./DomainPrivateWhois.vue?vue&type=template&id=baab27e6&"
import script from "./DomainPrivateWhois.vue?vue&type=script&lang=js&"
export * from "./DomainPrivateWhois.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports